import { MARKETING_DEMO_COMMENTS_SHEET_ABOVE_HUD_Z_CLASS } from "@marketing/home/lib/marketing-demo-topic-header-portal-layout";
import { cn } from "@repo/ui";

/**
 * Banner + navbar height (`MarketingSiteHeader` sets `--marketing-site-header-height`).
 * Sheets sit under the sticky marketing header (`MARKETING_SITE_HEADER_STACK_Z_CLASS`).
 */

/** Dimmed overlay only below banner + navbar (full width). */
export const marketingSheetUnderHeaderOverlayClassName = cn(
	"!z-[200]",
	"!top-[var(--marketing-site-header-height,7rem)] !right-0 !bottom-0 !left-0 !h-auto",
);

/**
 * Side sheets aligned under marketing chrome (same idea as SaaS comments sheets).
 */
export function marketingSheetContentChromeClassName(
	side: "left" | "right",
	className?: string,
) {
	return cn(
		"!z-[200]",
		(side === "left" || side === "right") &&
			cn(
				"!top-[var(--marketing-site-header-height,7rem)]",
				"!h-[calc(100dvh-var(--marketing-site-header-height,7rem))]",
				"!max-h-[calc(100dvh-var(--marketing-site-header-height,7rem))]",
			),
		className,
	);
}

/** Solution demo topic comments: full marketing chrome height, above player HUD row. */
export const marketingDemoTopicCommentsSheetStackClassNames = {
	overlayClassName: cn(
		marketingSheetUnderHeaderOverlayClassName,
		MARKETING_DEMO_COMMENTS_SHEET_ABOVE_HUD_Z_CLASS,
	),
	contentClassName: marketingSheetContentChromeClassName(
		"right",
		MARKETING_DEMO_COMMENTS_SHEET_ABOVE_HUD_Z_CLASS,
	),
};
